import React, { Component } from "react"
import {
    Link, Redirect
} from 'react-router-dom'
import CemacoLogo from "./cemaco-logo"
import { Auth } from 'aws-amplify'
import { faUser } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import getTheme from "../config/theme"

class Main extends Component {

    constructor(props) {
        super(props)
        this.state = {
            isLoggedIn: false,
            sesionVerificada: false
        }
        this.logout = this.logout.bind(this)
    }

    componentDidMount() {
        Auth.currentSession().then(data => {
            this.setState({
                isLoggedIn: true,
                sesionVerificada: true
            })
        }).catch(error => {
            this.setState({
                isLoggedIn: false,
                sesionVerificada: true
            })
        })
    }

    async logout() {
        Auth.signOut({"global": true})
        .then(data => {
            this.setState({
                isLoggedIn: false
            })
        })
    }

    render() {
        const theme = getTheme();
        
        if (!this.state.sesionVerificada) {
            return <h4>Verificando su su sesion</h4>
        } else {
            if (!this.state.isLoggedIn) return <Redirect to='/login' push />
            return (
                <div>
                    <nav className='navbar navbar-expand-lg navbar-dark'style={{
                        backgroundColor: theme.primaryNavbarColor
                    }}>
                        <Link to='/' className='navbar-brand'>
                            <CemacoLogo textColor={theme.navbarTextColor} logoType={theme.logoType}/>
                        </Link>
                        <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                            <span className="navbar-toggler-icon"></span>
                        </button>
                        <div className='collapse navbar-collapse' id='navbarSupportedContent'>
                            <ul className='navbar-nav mr-auto'>
                                <li className='nav-item'>
                                    <Link to='/deshabilitar' className='nav-link'>
                                        Deshabilitar
                                    </Link>
                                </li>
                                <li className='nav-item'>
                                    <Link to='/habilitar' className='nav-link'>
                                        Habilitar
                                    </Link>
                                </li>
                                <li className='nav-item'>
                                    <Link to='/cargar-excel' className='nav-link'>
                                        Importar Excel
                                    </Link>
                                </li>
                                <li className='nav-item'>
                                    <Link to='/reporte' className='nav-link'>
                                        Reporteria
                                    </Link>
                                </li>
                            </ul>
                            <ul className='navbar-nav ml-auto'>
                                <li className='nav-item dropdown'>
                                    <button className="btn btn-link nav-link dropdown-toggle" id="navbarDropdown" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <FontAwesomeIcon role='button' icon={faUser} />
                                    </button>
                                    <div className='dropdown-menu dropdown-menu-right' aria-labelledby='navbarDropdown'>
                                        <Link to='/perfil' className='dropdown-item'>
                                            Mi perfil
                                        </Link>
                                        <div className="dropdown-divider"></div>
                                        <button className='btn btn-link dropdown-item' onClick={this.logout}>Cerrar sesion</button>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </nav>
                    <div className='container'>
                        {this.props.children}
                    </div>
                </div>
            )
        }
    }
}

export default Main